import React from "react";
import {ListEditor} from "../../components/list-editor";
import * as yup from "yup";
import {
    Borough,
    BoroughQueryQuery,
    useBoroughQueryQuery, useBoroughsMutationMutation
} from "../../generated/graphql";
import {useLocation} from "react-router";
import {uniqueId} from "../../utils";

const columns = [{
    header: 'Name',
    accessor: 'label',
    dataType: 'text',
}
];


function newRow(): Borough {
    return {
        id: uniqueId(),
        label: ''
    };
}

const schema = yup.array().of(
        yup.object().shape({
            'label': yup.string().required()
        }).required()
);


function getValues(data: BoroughQueryQuery) {
    return data?.boroughs.data; // leaves DATA node
}

const Boroughs = () => {
    const url = useLocation().pathname;
    const query = useBoroughQueryQuery();
    const [mutation, mutationResult] = useBoroughsMutationMutation();

    return (
        <ListEditor
            columns={columns}
            className="boroughs"
            getValues={getValues}
            validationSchema={schema}
            permission="regional"
            title="Boroughs"
            query={query}
            mutation={mutation}
            newRow={newRow}
            saveResult={mutationResult}
            newRowLabel="Add Borough"
            baseUrl={url}
        />);
}

export default Boroughs;
